export default __webpack_public_path__ + "static/media/card_dexpro3.4b854874.png";